import 'bootstrap/lib/preBootstrap';
import 'owa-shared-bootstrap/lib/bootstrapWebpack';
// Important that this come first, to bootstrap webpack settings
import 'bootstrap/lib/applyTrustedTypesPolicy';
import { getAppNameFromUrl } from './utils/getAppNameFromUrl';
import { loadPolyfills } from '../../../pollyfills';
import { patchMobX } from 'owa-mobx4-adapter';
import { startCalendarBootstrap } from 'mini-calendar-bootstrap/lib/startCalendarBootstrap';
import { startMailBootstrap } from './startMailBootstrap';
import { startPeopleBootstrap } from 'mini-people-bootstrap/lib/startPeopleBootstrap';

loadPolyfills()
    .then(patchMobX)
    .then(() => {
        switch (getAppNameFromUrl()) {
            case 'Calendar':
                startCalendarBootstrap();
                break;
            case 'People':
            case 'ToDo':
                startPeopleBootstrap();
                break;
            default:
                startMailBootstrap();
                break;
        }
    });
